import { toast } from "sonner";
import { DealerRequestModel } from "../../domain/models/dealerModel";
import { DropResult } from "@hello-pangea/dnd";
import { RouteModel } from "../../domain/models/routeModel";

export default function RemoveRequestFromRoute(
  routes: RouteModel[],
  dealers: DealerRequestModel[],
  dropResult: DropResult,
): { routes: RouteModel[]; dealers: DealerRequestModel[] } {
  if (!dropResult.destination) {
    return {
      routes,
      dealers,
    };
  }

  // Get the draggable element.
  const draggable = dropResult.draggableId;
  const requestId = draggable.replace("request:", "");

  const request = routes
    .flatMap((r) => r.packingSlips)
    .flatMap((p) => p.requests)
    .find((request) => request.id === requestId);

  if (!request) {
    toast.error("Could not find request:" + requestId + " to move");
    return {
      routes,
      dealers,
    };
  }

  routes = routes.map((route) => {
    //Remove slip from old packing slip.
    route.packingSlips = route.packingSlips
      .map((slip) => {
        slip.requests = slip.requests.filter((req) => req.id !== request.id);
        return slip;
      })
      .filter((slip) => slip.requests.length > 0);
    return route;
  });

  // Add the request back to the dealers
  const existingDealer = dealers.find(
    (d) => d.relation.id === request.relation.id,
  );

  if (existingDealer) {
    existingDealer.deliver_requests.push(request);
  } else {
    dealers.push({
      relation: request.relation,
      deliver_requests: [request],
      pickup_amount: 0,
    });
  }

  return {
    routes,
    dealers,
  };
}
